module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-300.67041c17.ttf";